import React, { createContext, useState, useContext, useCallback } from 'react';

const PointsContext = createContext();

export const usePoints = () => useContext(PointsContext);

export const PointsProvider = ({ children }) => {
    const [animations, setAnimations] = useState([]);

    const triggerPointsAnimation = useCallback((amount, x, y) => {
        const id = Date.now();
        setAnimations(prev => [...prev, { id, amount, x, y }]);

        // Remove animation after 1.5 seconds
        setTimeout(() => {
            setAnimations(prev => prev.filter(anim => anim.id !== id));
        }, 1500);
    }, []);

    return (
        <PointsContext.Provider value={{ animations, triggerPointsAnimation }}>
            {children}
        </PointsContext.Provider>
    );
};
